import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Row, Table } from "react-bootstrap";
import ModalExcluirBase from "../../../Modal/ModalExcluirBase";
import Pagination from "../../../../Stores/Funcoes/Paginacao/Pagination";
import ModalEditarPorduto from "../../ModalConfiguracoes/ModalEditarPorduto";

@inject("ProdutosStores")
@observer
class TabPortaisConf extends Component {
  componentDidMount() {
      this.props.ProdutosStores.consultarProduto()
  }

  render() {
    return (
      <Row
        style={{
          paddingLeft: "0.8%",
          paddingRight: "0.8%",
          marginTop: "1%",
          marginBottom: "5%",
          fontSize: "15px",
        }}
      >
        <Table striped bordered condensed hover>
          <thead>
            <tr>
              <th style={{ width: "5%", textAlign: "center" }}>#</th>
              <th style={{ width: "25%" }}>PRODUTOS</th>
              <th style={{ width: "50%" }}>DESCRIÇÃO</th>
              <th style={{ width: "8%", textAlign: "center" }}>AÇÃO</th>
            </tr>
          </thead>
          <tbody>
            {this.props.ProdutosStores.produtos.map((produto, i) => {
              return (
                <tr key={produto.id}>
                  <td style={{ textAlign: "center" }}>{produto.id}</td>
                  <td>{produto.name}</td>
                  <td>{produto.description}</td>
                  <td style={{ textAlign: "center" }}>
                    <ModalEditarPorduto produto={produto} />
                    &nbsp;
                    <ModalExcluirBase
                      nome={produto.name}
                      onClick={() =>
                        this.props.ProdutosStores.delProduto(
                          produto.id,
                          produto.name
                        )
                      }
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        <Pagination
          totalRecords={this.props.ProdutosStores.produto_total}
          pageLimit={20}
          pageNeighbours={1}
          defaultCurrent={this.props.ProdutosStores.pagina_atual}
          onPageChanged={this.props.ProdutosStores.onPageChanged}
          key={this.props.ProdutosStores.produto_total}
        />
      </Row>
    );
  }
}

export default TabPortaisConf;
